import clsx from "clsx";
import styles from "./LegalNotice.module.scss";

export type LegalNoticeProps = {};

function LegalNotice(_: LegalNoticeProps) {
  const goToFinumContactFormular = () => {
    window.open("https://finumfinanzhaus.de/kontaktformular", "_blank");
  };

  return (
    <div className={styles.container}>
      <p className={clsx(styles.individuell)}>
        Ihre Altersvorsorge ist so individuell wie Sie!
      </p>
      <p className={clsx(styles.contactUs)}>
        Kontaktieren Sie uns hier für eine ganzheitliche Beratung, die auf Ihre
        individuelle Situation ausgerichtet ist und Ihre jeweiligen Ziele
        berücksichtigt.
      </p>
      <button
        className={styles.contactButton}
        onClick={goToFinumContactFormular}
      >
        Kontaktformular
      </button>
      <p className={clsx(styles.info)}>
        Dieser Rechner dient als grobe Orientierung zur Berechnung des
        erforderlichen Altersvermögens und einer möglicherweise bestehenden
        Lücke beim Vorsorgevermögen. Zur einfachen Handhabung nutzt der Rechner
        teilweise pauschale Annahmen, die im Einzelfall anders ausfallen können.
        Zudem werden Steuer- und Sozialabgaben in der Berechnung nicht
        berücksichtigt. Der Rechner begründet keinen Rechtsanspruch und ersetzt
        keine persönliche Beratung.
      </p>
    </div>
  );
}

export default LegalNotice;
